import { render, staticRenderFns } from "./loadingDetail.vue?vue&type=template&id=2805cd30&scoped=true&"
import script from "./loadingDetail.vue?vue&type=script&lang=js&"
export * from "./loadingDetail.vue?vue&type=script&lang=js&"
import style0 from "./loadingDetail.vue?vue&type=style&index=0&id=2805cd30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805cd30",
  null
  
)

export default component.exports